"use strict";

var ToastStrStaticModule = (function () {
    return {
        Get: function () {
            return {
                Error: {
                    REQUIRED_LOGIN_CREDENTIALS: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'Escriba su Correo/Usuario y contraseña.'
                    },
                    INVALID_LOGIN_CREDENTIALS: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'Sus datos de acceso son incorrectos. Inténtelo de nuevo o póngase en contacto con el administrador.'
                    },
                    EMAIL_ALREADY_IN_USE: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El correo electrónico ingresado ya está asociado a una cuenta. Por favor utiliza otro.'
                    },


                    INVALID_TOKEN: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'Su token se ha utilizado o no es válido. Comuníquese con el administrador del sitio.'
                    },
                    INVALID_LOGIN_SUB_ACCOUNT_DISABLED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'Sub account login is disabled by admin.'
                    },
                    REQUIRED_EMAIL_OR_USERNAME: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'Escriba su Correo/Usuario y contraseña.'
                    },
                    PLEASE_SELECT_A_DELIVERY_ADDRESS_TO_PROCEED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'Seleccione una dirección de entrega antes de continuar.'
                    },
                    PLEASE_SELECT_A_RECORD_TO_PROCEED: {
                        type: 'error',
                        header: '',
                        body: 'Seleccione un registro para continuar..'
                    },
                    PASSWORD_ERRORS: {
                        PASSWORD_MUST_CONTAIN_SIX_CHARACTERS: {
                            type: 'error',
                            header: 'Estimado usuario',
                            body: 'La contraseña debe contener al menos 6 caracteres.'
                        },
                        PASSWORD_CONFIRM_DOESNT_MATCH: {
                            type: 'error',
                            header: 'Estimado usuario',
                            body: 'La contraseña es incorrecta. '
                        },
                        OLD_PASSWORD_DOESNT_MATCH: {
                            type: 'error',
                            header: 'Estimado usuario',
                            body: 'Antigua contraseña es incorrecta.'
                        },
                    },
                    USER_NAME_PASSWORD_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El Correo/Usuario y la contraseña es requerida.'
                    },
                    ITEM_HAS_NOT_STOCK: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'Actualmente el producto seleccionado no cuenta con existencias, si lo deseas, puedes contactar directamente al vendedor.'
                    },
                    FIRST_NAME_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El Nombre es requerido.'
                    },
                    LAST_NAME_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El Apellido es requerido.'
                    },
                    PHONE_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El Telefono es requerido.'
                    },
                    PHONE_NOT_MATCH: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El Telefono no puede contener letras.'
                    },
                    EMAIL_NOT_MATCH: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El Correo no tiene el formato correcto.'
                    },
                    RAZON_SOCIAL_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'La Razon Social es requerida.'
                    },
                    RFC_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El RFC es requerido.'
                    },
                    REGIMEN_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El Regimen Fiscal es requerido.'
                    },
                    PLEASE_FILL_OUT_THE_REQUIRED_FIELD_TO_PROCEED: {
                        type: 'error',
                        header: '',
                        body: 'Por favor complete los campos requeridos para continuar.'
                    },
                    SHIPPING_ALIAS_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El Alias de envío es requerido.'
                    },
                    SHIPPING_NAME_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El Nombre de contacto en datos de envío es requerido.'
                    },
                    SHIPPING_LASTNAME_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El Apellido de contacto en datos de envío es requerido.'
                    },
                    SHIPPING_ADDRESS_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'La direccion de envío es requerida.'
                    },
                    SHIPPING_STATE_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El estado de envío es requerido.'
                    },
                    SHIPPING_CITY_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'La ciudad de envío es requerida.'
                    },
                    SHIPPING_ZIP_CODE_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El codigo postal de envío es requerido.'
                    },
                    BILLING_ALIAS_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El Alias de facturacion es requerido.'
                    },
                    BILLING_NAME_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El Nombre de contacto en datos de facturacion es requerido.'
                    },
                    BILLING_LASTNAME_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El Apellido de contacto en datos de facturacion es requerido.'
                    },
                    BILLING_ADDRESS_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'La direccion de facturacion es requerida.'
                    },
                    BILLING_STATE_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El estado de facturacion es requerido.'
                    },
                    BILLING_CITY_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'La ciudad de facturacion es requerida.'
                    },
                    BILLING_ZIP_CODE_REQUIRED: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El codigo postal de facturacion es requerido.'
                    },
                    ITEM_VISIBILITY_DISABLED_BY_ADMIN: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El administrador del sitio ha inhabilitado la visibilidad del artículo.'
                    },
                    ITEM_VISIBILITY_DISABLED_BY_ADMIN_OR_MERCHANT: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'La visibilidad del artículo ha sido inhabilitada (por el administrador del sitio o el comerciante).'
                    },
                    FAILED_ITEM_VISIBILITY_UPDATE: {
                        type: 'error',
                        header: 'Estimado usuario',
                        body: 'El administrador del sitio ha inhabilitado la visibilidad del artículo.'
                    },
                    INVALID_SUB_ACCOUNT_EMAILS: {
                        type: 'error',
                        header: 'Error',
                        body: 'Uno de los correos electrónicos no es válido.'
                    },
                    INVALID_EMAILS: {
                        type: 'error',
                        header: 'Error',
                        body: 'Formato de correo inválido.'
                    },
                    INVALID_PROFILE_PICTURE: {
                        type: 'error',
                        header: 'Error',
                        body: 'Se requiere una foto de perfil.'
                    },
                    FAILED_SUB_ACCOUNT_DELETE: {
                        type: 'error',
                        header: 'Error',
                        body: 'Hubo un error al intentar eliminar la subcuenta.'
                    },
                    FAILED_SUB_ACCOUNT_INVITE: {
                        type: 'error',
                        header: 'Error',
                        body: 'Se produjo un error al intentar enviar la invitación por correo electrónico.'
                    },
                    NO_ORDER_SELECTED_TO_UPDATE: {
                        type: 'error',
                        header: 'Error',
                        body: 'Por favor seleccione un pedido.'
                    },
                    INVALID_SUB_MERCHANT_REGISTRATION: {
                        type: 'error',
                        header: 'Oops! Something went wrong.',
                        body: 'We cannot get your login details from the provider, please try logging in again.'
                    },
                    CHECKOUT_ITEM_HAS_BEEN_UPDATED: {
                        type: 'error',
                        header: '',
                        body: 'Checkout failed! Item details have been updated, please remove and compare the item again.'
                    },
                    UNREGISTERED_LOGIN_ACCOUNT: {
                        type: 'error',
                        header: 'Oops! Something went wrong.',
                        body: 'You are not allowed to access the marketplace. Please contact the administrator.'
                    },
                    FAILED_ADD_DISABLED_ITEM_TO_COMPARISON: {
                        type: 'error',
                        header: 'Oops! Something went wrong.',
                        body: 'You cannot add a deleted/unavailable item to comparison table.'
                    },
                    CHECKOUT_PAYMENT_DO_NOT_SUPPORT_MULTIPLE_ORDERS: {
                        type: 'error',
                        header: 'Oops! Something went wrong.',
                        body: 'Selected payment method does not support multi-merchant checkout, please select items from only one seller and checkout again'
                    },
                    REQUIRED_DELIVERY_RATE_DETAILS: {
                        type: 'error',
                        header: 'Error',
                        body: 'Please add delivery rates.'
                    },
                    CANCEL_QUOTATION_FAILED: {
                        type: 'error',
                        header: 'Oops! Something went wrong.',
                        body: 'Unable to cancel quotation. Please try again or contact the administrator.'
                    },
                    DECLINE_QUOTATION_FAILED: {
                        type: 'error',
                        header: 'Oops! Something went wrong.',
                        body: 'Unable to decline quotation. Please try again or contact the administrator.'
                    },
                    CREATE_INVOICE_FAILED: {
                        type: 'error',
                        header: 'Oops! Something went wrong.',
                        body: 'Unable to create invoice by cart items. Please try again or contact the administrator.'
                    },
                    CREATE_ORDER_FAILED: {
                        type: 'error',
                        header: 'Oops! Something went wrong.',
                        body: 'Unable to create order by cart items. Please try again or contact the administrator.'
                    },
                    INVALID_SERVICE_BOOKING: {
                        type: 'error',
                        header: 'Oops! Something went wrong.',
                        body: 'Failed to book the selected session, please try again.'
                    },
                    INSUFFICIENT_STOCK: {
                        type: 'error',
                        header: 'Oops! Something went wrong.',
                        body: 'The time period that you have selected has been completely booked out, please try choosing another.'
                    },
                    SESION_NO_INICIADA: {
                        type: 'error',
                        header: 'Oops!',
                        body: 'Para ingresar a la ruta solicitada, debes iniciar sesión.'
                    },
                },
                Success: {
                    DATA_SUCCESSFULLY_SAVED: {
                        type: 'success',
                        header: '',
                        body: ''
                    },
                    SUCCESS_SUB_ACCOUNT_INVITE: {
                        type: 'success',
                        header: 'Success!',
                        body: 'Invites had been successfully sent.'
                    },
                    UPDATED_ITEM_PURCHASABILITY: {
                        type: 'success',
                        header: 'Success!',
                        body: 'Item\'s availability was successfully updated.'
                    },
                    REGISTERED_ACCOUNT: {
                        type: 'success',
                        header: 'Registrado',
                        body: 'Cuenta registrada con éxito.'
                    }
                }
            }
        }
    };

})();

module.exports = ToastStrStaticModule;